import { Link } from "react-router-dom";

import "./ThankYou07.css";

import SeoHead from "../../../seo/SeoHead";
import {
  THANK_YOU_PAGE_DESCRIPTION,
  THANK_YOU_PAGE_TITLE,
} from "../../../seo/siteConfig";

function ThankYou07() {
  return (
    <div className="ThankYou07 section" id="ThankYou07">
      <SeoHead
        title={THANK_YOU_PAGE_TITLE}
        description={THANK_YOU_PAGE_DESCRIPTION}
        path="/thank-you"
        noIndex
      />
      <div className="container">
        <div className="ThankYou07-box">
          <p className="eyebrow">THANK YOU</p>
          <h1>We received your application</h1>
          <p>
            Our team reviews submissions regularly. If your profile fits our
            network, we will reach out soon.
          </p>
          <Link to="/" className="btn-3">
            Back to homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ThankYou07;
